// extracted by mini-css-extract-plugin
module.exports = {"col-md-4":"General_col-md-4__oskqc","aBlockTitle":"General_aBlockTitle__MPqgc","aTitle":"General_aTitle__xH022","oGeneralSectionBlock":"General_oGeneralSectionBlock__xedMU"};